export const PROFILE_ENV = process.env.REACT_APP_PROFILE || '' 
export const APP_VERSION = process.env.REACT_APP_VERSION || 'demo';